import type { EMobilContract, InsuredEMobil } from '@/types/emobil/EMobilContract'
import { isEMobilContract } from '@/types/emobil/EMobilContract'
import type { DataBlock, SingleBlock, TitleBlock } from 'de-zurich-ui-library'
import { n, t } from '@/i18n'

export function sortInsuredEMobilBySequence(a: InsuredEMobil, b: InsuredEMobil): number {
  const nameA = a.sequence!
  const nameB = b.sequence!
  if (nameA < nameB) {
    return -1
  }
  if (nameA > nameB) {
    return 1
  }

  // names must be equal
  return 0
}

export class EMobilDetailsFactory {
  createDetails(contract: EMobilContract | null, databoxData: DataBlock[]): void {
    if (!contract || !isEMobilContract(contract)) return

    const vehicles: InsuredEMobil[] = contract.insuredVehicle
    if (!vehicles) return

    vehicles.sort(sortInsuredEMobilBySequence)

    for (const vehicle of vehicles) {
      const insuredEMobile: DataBlock = new (class implements DataBlock {
        data: SingleBlock[] = []
        subtitle?: TitleBlock
        title?: TitleBlock
      })()

      if (vehicles.length > 1) {
        insuredEMobile.title = {
          label: t('emobileDetails.title.sequence', {
            sequence: vehicle.sequence?.toString()
          })
        }
      } else {
        insuredEMobile.title = {
          label: t('emobileDetails.title.no_sequence', {
            sequence: vehicle.sequence?.toString()
          })
        }
      }

      this.createDatablocks(insuredEMobile, vehicle)
      databoxData.push(insuredEMobile)
    }
  }

  private createDatablocks(insuredEMobile: DataBlock, vehicle: InsuredEMobil) {
    if (vehicle.yearOfProduction) {
      if (vehicle.yearOfProduction === '0000') {
        insuredEMobile.data.push({
          label: t('emobileDetails.yearOfProduction'),
          value: t('emobileDetails.yearOfProduction_no_info'),
          hide: false
        })
      } else {
        insuredEMobile.data.push({
          label: t('emobileDetails.yearOfProduction'),
          value: vehicle.yearOfProduction,
          hide: false
        })
      }
    }
    insuredEMobile.data.push(
      {
        label: t('emobileDetails.manufacturer'),
        value: vehicle.manufacturer,
        hide: !vehicle.manufacturer
      },
      {
        label: t('emobileDetails.identification'),
        value: vehicle.identification,
        hide: !vehicle.identification
      },
      {
        label: t('emobileDetails.type'),
        value: vehicle.type,
        hide: !vehicle.type
      }
    )
    if (!vehicle.insuredSum || vehicle.insuredSum === 0) {
      insuredEMobile.data.push({
        label: t('emobileDetails.insuredSum'),
        value: t('emobileDetails.insuredSum_no_info'),
        hide: false
      })
    }

    if (vehicle.insuredSum) {
      insuredEMobile.data.push({
        label: t('emobileDetails.insuredSum'),
        value: n(vehicle.insuredSum, {
          key: 'currency',
          currency: 'EUR',
          locale: 'de-DE'
        }),
        hide: !vehicle.insuredSum
      })
    }
    if (vehicle.deductible) {
      insuredEMobile.data.push({
        label: t('emobileDetails.deductible'),
        value: n(vehicle.deductible, {
          key: 'currency',
          currency: 'EUR',
          locale: 'de-DE'
        }),
        hide: false
      })
    } else {
      insuredEMobile.data.push({
        label: t('emobileDetails.deductible'),
        value: '0 EUR',
        hide: false
      })
    }
  }
}
